import { Button } from 'antd';

import type { NEmployees } from '@app/types/Employees';

export const SaveButton = (data: NEmployees.SortEmployeesSavingButtonProps) => {
  const { saveEmployees, isSaving } = data;

  return (
    <Button
      type="primary"
      className="save-button"
      onClick={saveEmployees}
      loading={isSaving}
      data-testid="save"
    >
      Сохранить
    </Button>
  );
};
